import { AdminOrder } from "@in-and-out-belleza/api/interfaces"
import { atom } from "jotai"

const _lastOrder = atom<AdminOrder | null>(null)

export { _lastOrder as _lastOrderAmount }
